import { useEffect } from 'react'

/** for overlays running `modal={false}`, where radix locks nothing and the
 *  page scrolls behind them. */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [locked])
}
